import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { css } from '@emotion/core';
import { Button } from 'antd';
import { fontSize } from '../../../constants';

@inject('settingsStore')
class CustomPlan extends Component {
  render() {
    return (
      <div
        css={css`
          margin-bottom: 10px;
          font-size: ${fontSize.medium};
        `}
      >
        Need a custom plan?
        <Button
          onClick={() => this.props.goToSlide()}
          type="button"
          size="small"
          css={css`
            margin-left: 10px;
          `}
        >
          Customize
        </Button>
      </div>
    );
  }
}

export default CustomPlan;
